import { render, staticRenderFns } from "./Note_Form.vue?vue&type=template&id=74dc52d3&"
import script from "./Note_Form.vue?vue&type=script&lang=js&"
export * from "./Note_Form.vue?vue&type=script&lang=js&"
import style0 from "./Note_Form.vue?vue&type=style&index=0&id=74dc52d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports